import * as tslib_1 from "tslib";
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { lazyGetLastestNonDraftItemId, lazyLoadConversationReadingPane, } from 'owa-mail-reading-pane-store';
function getLatestNonDraftItemIdFromConversation(conversationId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var getLatestNonDraftItemId, conversation, loadConversationReadingPane;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyGetLastestNonDraftItemId.import()];
                case 1:
                    getLatestNonDraftItemId = _a.sent();
                    if (!!getLatestNonDraftItemId(conversationId)) return [3 /*break*/, 4];
                    conversation = listViewStore.conversationItems.get(conversationId.Id);
                    if (!conversation) return [3 /*break*/, 4];
                    return [4 /*yield*/, lazyLoadConversationReadingPane.import()];
                case 2:
                    loadConversationReadingPane = _a.sent();
                    return [4 /*yield*/, loadConversationReadingPane(conversationId, null /* instrumentationContext */, conversation.subject)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/, getLatestNonDraftItemId(conversationId)];
            }
        });
    });
}
export default getLatestNonDraftItemIdFromConversation;
//# sourceMappingURL=getLatestNonDraftItemIdFromConversation.js.map